import { Component } from '@angular/core';

@Component({
  selector: 'app-agent-chat-input',
  // imports: [],
  templateUrl: './agent-chat-input.component.html',
  styleUrl: './agent-chat-input.component.scss'
})
export class AgentChatInputComponent {

}
